import { format } from 'date-fns';

export function formatDisplayDate(dateStr) {
  if (!dateStr) return 'N/A';

  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getCurrentDate() {
  return toLocalDateString(new Date());
}

export function getLocalTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

export function toLocalDateString(date) {
  return format(date instanceof Date ? date : new Date(date), 'yyyy-MM-dd');
}

export function secondsToTime(seconds) {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const segs = seconds % 60;

  const daysStr = `${days ? `${days} day${days > 1 ? 's' : ''}, ` : ''}`;
  const hoursStr = `${hours ? `${hours} hour${hours > 1 ? 's' : ''}, ` : ''}`;
  const minutesStr = `${minutes ? `${minutes} minute${minutes > 1 ? 's' : ''} and ` : ''}`;
  const segsStr = `${segs} second${segs !== 1 ? 's' : ''}`;

  return daysStr + hoursStr + minutesStr + segsStr;
}
